import { useEffect } from "react";

/**
 * Signals to the post-build Puppeteer prerenderer that the current page is
 * fully rendered and ready to be captured.
 *
 * Use this in every public page. For pages that fetch data asynchronously,
 * pass `ready=false` until the required content is available.
 */
export function usePrerenderReady(ready = true) {
    useEffect(() => {
        if (typeof window === "undefined") {
            return;
        }

        window.__PRERENDER_READY__ = ready;

        return () => {
            window.__PRERENDER_READY__ = false;
        };
    }, [ready]);
}
